import { importClassOnScroll } from "../../utilities/dynamicImportsUtility";
import { invWidgetResources } from "./utilities/inventoryWidgetResources";

/**
 * Imports the Inventory Widget when an inventory-widget element is scrolled into the window
 */
export default class InventoryWidget extends HTMLElement {
  public constructor() {
    super();
  }

  public connectedCallback() {
    console.log("inventory search widget registered");
    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", () => this.initialize());
    } else {
      this.initialize();
    }
  }

  private initialize() {
    /* While data is populating, show a Loading placeholder */
    const inputs = Array.from(
      this.querySelectorAll(`[${invWidgetResources.filterAttribute}]`)
    );
    for (const input of inputs) {
      if (
        input instanceof HTMLSelectElement &&
        input.getAttribute(invWidgetResources.filterAttribute) !==
          invWidgetResources.staticFilter
      ) {
        input.innerHTML = new Option("Loading...", "").outerHTML;
      }
    }

    importClassOnScroll(
      () =>
        import(
          /* webpackChunkName: "inventoryWidgetController" */ "./inventoryWidgetController"
        ),
      this,
      true,
      null,
      this
    );
  }
}

customElements.define("inventory-widget", InventoryWidget);
